// extracted by css-extract-rspack-plugin
export default {"bgBlue":"bgBlue-RkZFOV"};